import React, {createContext, useContext, useEffect, useState} from 'react';
import KioskNavbar from "../app/navbars/KioskNavbar";
import {AppContext} from "./AppContext";

const KioskViewContext = createContext();

export function KioskViewProvider({ children }) {
  const [context, setContext] = useContext(AppContext);
  const [kioskMode, setKioskMode] = useState(false);
  const [client, setClient] = useState(null);
  const [type, setType] = useState('inventory');

  const toggleKioskMode = (type, open,client) => {
    if (client) {
      putClient(client);
    }
    if (open) {
      setKioskMode(true);
    } else {
      setKioskMode(prev => !prev)
    }
    if (type !== 'last') {
      setType(type);
    }
  };

  useEffect(()=>{
    if (!kioskMode) {
      setContext({...context, refresh: true});
    }
  },[kioskMode])

  const putClient = (c) => {
    setClient(c)
  };

  const pullClient = (c) => {
    setClient(null);
  };

  const [callbackResp, setCallbackResp] = useState('');

  return (
    <KioskViewContext.Provider value={{ toggleKioskMode, putClient, pullClient }}>
      {children}
      {kioskMode && <KioskNavbar
                                 client={client}
                                 open={kioskMode}
                                 type={type}
                                 handleClose={(e) => {
                                   setKioskMode(false);
                                   setClient(null);
                                 }}
                                 handleSave={(e) => {
                                   setKioskMode(false);
                                 }}
      />}
    </KioskViewContext.Provider>
  );
}


export function useKiosk() {
  const context = useContext(KioskViewContext);
  if (!context) {
    throw new Error('KioskViewContext must be used within a KioskViewContext');
  }
  return context;
}

